import { CommonModule } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { ButtonComponent } from '@atoms/button/button.component';
import { SvgIconComponent } from '@components/svg-icon/svg-icon.component';
import { SvgIcon } from '@services/svg-icon.service';

export interface SystemErrorBottomSheetData {
  title?: string;
  body?: string;
  confirmLabel?: string;
}

@Component({
  selector: 'app-system-error-modal',
  standalone: true,
  imports: [CommonModule, ButtonComponent, SvgIconComponent],
  templateUrl: './system-error-modal.component.html',
})
export class SystemErrorModalComponent {
  protected readonly SvgIcon = SvgIcon;

  private readonly bottomSheetRef = inject(MatBottomSheetRef<SystemErrorModalComponent>);
  protected readonly data = inject<SystemErrorBottomSheetData>(MAT_BOTTOM_SHEET_DATA, { optional: true }) ?? {};

  private readonly defaultBody = 'Hubo un problema con el sistema. Por favor inténtalo de nuevo en unos minutos.';
  private readonly bodySignal = signal<string>(this.resolveBody(this.data.body));

  get body(): string {
    return this.bodySignal();
  }

  readonly bodyLines = computed(() => this.bodySignal().split(/\r?\n/).filter(Boolean));

  get title(): string {
    return this.data.title?.trim() || '¡Algo salió mal!';
  }

  get confirmLabel(): string {
    return this.data.confirmLabel?.trim() || 'Entendido';
  }

  private resolveBody(value?: string): string {
    return value?.trim() ? value : this.defaultBody;
  }

  onClose(): void {
    this.bottomSheetRef.dismiss('close');
  }

  onConfirm(): void {
    this.bottomSheetRef.dismiss('confirm');
  }
}

